import { computed, inject, Injectable, type Signal } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { injectMenuQuery } from '@features/navigation/queries/navigation.queries';
import type { MenuModulo } from '@features/navigation/models/navigation.model';
import type { MenuItem } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class NavigationStore {
    private readonly transloco = inject(TranslocoService);
    private readonly menuQuery = injectMenuQuery();

    readonly isLoading: Signal<boolean> = computed(() => this.menuQuery.isLoading());

    readonly error: Signal<Error | null> = computed(() => this.menuQuery.error());

    readonly menu: Signal<MenuModulo[]> = computed(() => this.menuQuery.data() ?? []);

    readonly menuItems: Signal<MenuItem[]> = computed(() => {
        const lang = this.transloco.activeLang();
        return this.menu().map((modulo) => ({
            label: lang === 'es' ? modulo.descripcionEs : modulo.descripcionEn,
            items: modulo.paginas.map((pagina) => ({
                label: lang === 'es' ? pagina.descripcionEs : pagina.descripcionEn,
                icon: pagina.icon,
                routerLink: `/${pagina.route}`,
                iconClass: 'text-2xl',
            })),
        }));
    });
}
